import * as Yup from 'yup';

import { emailSchema, passwordSchema } from './auth';
import { merchantEmailSchema, nameSchema, personNameSchema, phoneFieldSchema } from './common';

export const phoneSchema = phoneFieldSchema.required('Phone is required');

/**
 * Add/edit forms for admin-managed people (Admin Users, Business Users).
 * `phone` is stored as `${countryCodeDigits}${nationalDigits}` (see PhoneNumberField), so
 * validation strips the country code before checking for a 10-digit national number.
 */
export const manageUserSchema = Yup.object({
  firstName: personNameSchema('First name'),
  lastName: personNameSchema('Last name'),
  email: merchantEmailSchema,
  countryCode: Yup.string().required(),
  phone: Yup.string()
    .test('valid-phone', 'Enter a valid phone number', function (value) {
      const digits = String(value ?? '').replace(/\D/g, '');
      const codeDigits = String(this.parent.countryCode ?? '').replace(/\D/g, '');
      const national =
        codeDigits && digits.startsWith(codeDigits) ? digits.slice(codeDigits.length) : digits;
      return national.length === 10;
    })
    .required('Phone number is required'),
});

export const profileSchema = Yup.object({
  name: nameSchema,
  email: emailSchema,
  phone: phoneFieldSchema.optional(),
});

export const changePasswordSchema = Yup.object({
  currentPassword: Yup.string().required('Current password is required'),
  newPassword: passwordSchema,
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('newPassword')], 'Passwords must match')
    .required('Confirm password is required'),
});
